import { useCallback } from "react";
import { useExportBatchHistory } from "../../../hooks/queries/useBulkUploadsQueries";
import { toastService } from "../../../providers";

export const useBulkUploadsExport = (apiFilters = {}) => {
  const { mutate: exportBatchHistory, isPending } =
    useExportBatchHistory(apiFilters);

  const handleExport = useCallback(() => {
    toastService.info("Exporting. Your download will begin shortly...");

    exportBatchHistory(undefined, {
      onSuccess: (response) => {
        const blob = response.data;
        const url = globalThis.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `bulk_uploads_${new Date().toISOString().slice(0, 10)}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
        toastService.success("Export complete! Download started.");
      },
      onError: () => {
        toastService.error("Failed to export. Please try again.");
      },
    });
  }, [exportBatchHistory]);

  return {
    handleExport,
    isExporting: isPending,
  };
};

export default useBulkUploadsExport;
